import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const DELETE_REF_TASK_FROM_PATHWAYS = "DELETE_REF_TASK_FROM_PATHWAYS";

export const service = async (data) => {
  const options: object = {
    url: `/Api/RefTask/DeleteRefTaskFromAuditPathways`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = await callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_REF_TASK_FROM_PATHWAYS, service, mock);
